export const EBonusConfigType = [
    {key: '0', text: 'Carga no motor', value: 'EngineLoad'},
    {key: '1', text: 'Inércia', value: 'Inertia'},
    {key: '2', text: 'Exceção de carga no motor', value: 'EngineLoadException'},
]